import React, { useEffect, useState } from 'react';
import moment from 'moment';
import RangePicker from '../../../shared/Point/Filters/RangePicker/RangePicker';
import { SPORTSBOOK_FILTER_PERIODS } from '../../../../constants/defaultValues';
import { getSportBookReport, resetSportsBook } from '../../../../store/actions/reports';
import { useDispatch } from 'react-redux';

const rangePeriod = SPORTSBOOK_FILTER_PERIODS.find(period => period.key === 'range');

export default function Filters({ initialPeriod, startDate, endDate, setDates }) {
    const dispatch = useDispatch();

    const [selectedPeriod, setSelectedPeriod] = useState(initialPeriod);

    const clearDates = () => {
        setDates([null, null]);
    };

    const clearReportData = () => {
        dispatch(resetSportsBook());
    };

    const clearAll = () => {
        clearDates();
        clearReportData();
    };

    const onReset = () => {
        clearAll();
        setSelectedPeriod(rangePeriod);
    };

    const getReportData = (startDate, endDate) => {
        if (startDate && endDate) {
            dispatch(getSportBookReport(startDate, endDate));
        }
    };

    const onPeriodChange = period => {
        clearAll();
        setSelectedPeriod(period);

        if (period.key !== rangePeriod.key) {
            const { startTime, endTime } = period.getRange();
            setDates([startTime, endTime]);
            getReportData(startTime, endTime);
        }
    };

    const handleDateChange = (date, callback) => {
        if (date) {
            clearReportData();
            setSelectedPeriod(rangePeriod);
            callback();
        }
    };

    const onStartDateChange = date => {
        handleDateChange(date, () => {
            date.setHours(0, 0, 0, 0);
            setDates([date.getTime(), endDate]);
        });
    };

    const onEndDateChange = date => {
        handleDateChange(date, () => {
            date.setHours(23, 59, 59, 999);
            setDates(() => [startDate, date.getTime()]);
        });
    };

    useEffect(() => {
        getReportData(startDate, endDate);
    }, []);

    return (
        <div className='filters'>
            <RangePicker
                periods={SPORTSBOOK_FILTER_PERIODS}
                selectedPeriod={selectedPeriod}
                onPeriodChange={onPeriodChange}
                startDate={startDate}
                endDate={endDate}
                onStartDateChange={onStartDateChange}
                onEndDateChange={onEndDateChange}
                onSearch={getReportData}
                onReset={onReset}
                showTime
            />
        </div>
    );
}
